<template>
  <div class="homeBody">
     <HomeDialog @Rapid="RapidS" ref="HomeDialog"/>
    <el-row :gutter="firstRowGutter">
      <div class="firstRow">
        <el-col :xs="firstColXs" :sm="firstColSm" :md="firstColMd" :lg="13" :xl="12">
          <el-card class="box-card" style="position: relative;">
            <div class="headPortrait">
              <img src="../../assets/images/head.png" alt="" style="width:100%;height:100%">
            </div>
            <div class="personage">
              <p class="personageP">HI，system</p>
              <p class="personagePone">超级管理员 | 超级管理员</p>
            </div>
            <div class="abnormal">
              <p class="abnormalP">本月异常考勤</p>
              <p style="color:#2878FF;font-weight: 600;">234</p>
            </div>
            <div class="abnormalone">
              <p class="abnormalP">审批中的流程</p>
              <p style="color:#2878FF;font-weight: 600;">124</p>
            </div>
          </el-card>
        </el-col>
        <el-col :xs="firstColXs" :sm="firstColSm" :md="firstColMd" :lg="5" :xl="5">
          <el-card class="box-card">
            <div class="task">
              <p style="font-size:13px;color:#999;">今日待办汇总</p>
              <br/>
              <br/>
              <p style="font-weight: 600;font-size:24px;"> 728 <span style="font-weight: 400;font-size:13px;color: #909399;"> 笔</span></p>
              <div class="taskPhotone">
                <img src="../../assets/images/待办汇总@2x.png" alt="" style="width:100%;height:100%">
              </div>
            </div>
          </el-card>
        </el-col>
        <el-col :xs="firstColXs" :sm="firstColSm" :md="firstColMd" :lg="6" :xl="7" class="cardBox">
          <el-card class="box-card">
            <div class="task" style="width:440px;">
              <p style="font-size:13px;color:#999;">本月处理任务量</p>
              <br/>
              <p style="font-weight: 600;font-size:24px;"> 1426 </p>
              <br/>
              <div style="width:140px;height:20px;float:left;margin-top:10px">
                <span style="color:#999;font-size:13px;"> 环日比 </span><span style="font-size:13px;"> 34.6% </span>
                <div style="float:right;width:20px;height:20px;margin-top:-2px;margin-right:25px"> <img src="../../assets/images/dkw_提升@3x.png" alt="" style="width:100%;height:100%;"></div>
              </div>
              <div style="width:130px;height:20px;float:left;margin-left:20%;margin-top:10px">
                <span style="color:#999;font-size:13px;"> 周同比 </span><span style="font-size:13px;"> 11.4% </span>
              <div style="float:right;width:20px;height:20px;margin-top:-2px;margin-right:25px"> <img src="../../assets/images/dkw_下降3x.png" alt="" style="width:100%;height:100%;"></div>

              </div>
              <div class="taskPhoto">
                <img src="../../assets/images/任务量@2x.png" alt="" style="width:100%;height:100%">
              </div>
            </div>
          </el-card>
        </el-col>
      </div>
      <div class="secondRow">
        <el-col :xs="firstColXs" :sm="firstColSm" :md="firstColMd" :lg="13" :xl="12">
          <el-card class="box-card">
            <div class="shortcut">
              <span>快捷导航</span>
              <div @click="shortcutClick()">
                <img src="../../assets/images/3.1 设置@2x.png" alt="" style="cursor:pointer;width:70%;height:70%">
              </div>
            </div>
            <div v-for="(val,index) in RapidList" :key="index" class="quick">
              <div style="margin-bottom:16px;">
                <img :src="val.img" alt="" style="width:100%;height:100%">
              </div>
              <span>{{val.name}}</span>
            </div>
          </el-card>
        </el-col>
         <el-col :xs="firstColXs" :sm="firstColSm" :md="firstColMd" :lg="11" :xl="12">
          <el-card class="box-card">
            <div class="notice">
              <span>通知公告</span>
              <u style="cursor:pointer;">更多></u>
            </div>
            <div class="proclamation">
              <span style="color:#FF7143;font-size:14px;">【公告通知】</span>
              <div class="proclamationDiv">关于组建永绿置业集团专业小组的通知</div><div class="Stick">置顶</div>
              <div class="proclamationD1">2021-12-06</div>
            </div>
             <div class="proclamation">
              <span style="color:#FF7143;font-size:14px;">【公告通知】</span>
              <div class="proclamationDiv">关于李艳霞同志的任命通知</div>
              <div class="proclamationD">2021-12-06</div>
            </div>
             <div class="proclamation">
              <span style="color:#FF7143;font-size:14px;">【公告通知】</span>
              <div class="proclamationDiv">作业指导书应知应会考核方案</div>
              <div class="proclamationD">2021-12-06</div>
            </div>
             <div class="proclamation">
              <span style="color:#FF7143;font-size:14px;">【公告通知】</span>
              <div class="proclamationDiv">关于组建永绿置业集团专业小组的通知</div>
              <div class="proclamationD">2021-12-06</div>
            </div>
          </el-card>
        </el-col>
      </div>
      <div class="thirdRow">
        <el-col :xs="thirdColXs" :md="thirdColMd" :lg="13" :xl="12">
          <el-card class="box-card">
            <div class="backlog">
              <span>待办事项</span>
            </div>
            <el-table :data="tableData" style="width: 100%;" >
              <el-table-column type="index" label="序号" ></el-table-column>
              <el-table-column prop="Type" label="任务类型"></el-table-column>
              <el-table-column prop="FQName" label="发起人"></el-table-column>
              <el-table-column prop="FQBM" label="发起人所在部门" ></el-table-column>
              <el-table-column prop="HJ" label="当前环节"></el-table-column>
              <el-table-column prop="HJNAME" label="环节办理人"></el-table-column>
              <el-table-column prop="tIME" label="上报时间"></el-table-column>
            </el-table>
          </el-card>
        </el-col>
        <el-col :xs="thirdColXs" :md="thirdColMd" :lg="11" :xl="12">
          <el-card class="box-card">
            <div class="attendance">
              <span>工作统计</span>
            </div>
            <div class="attendanceOne">
               <el-calendar v-model="value">
                  <template slot="dateCell" slot-scope="{ data }" >
                    <p>{{ data.day.split("-").slice(2).join("-") }}<br/></p>
                    
                    <div
                      v-for="(item, index) in calendarData"
                      :key="index"
                    >
                    <div slot="dateCell"
                      @click="calendarOnClick(data)">
                      <div v-if="data.day == item.day" style="font-size:12px;">
                        <div v-if="item.type == '1'" style="width:7px;height:7px;border-radius:6px;background: #FF4D4F;margin-left:33px;">
                        </div>
                        <div v-if="item.type == '2'" style="width:7px;height:7px;border-radius:6px;background: #13DFA0;margin-left:33px;">
                        </div>
                        <div v-if="item.type == '0'" style="width:7px;height:7px;border-radius:6px;background: #fff;margin-left:33px;">
                        </div>
                      </div>
                      </div>
                    </div>
                  </template>
               </el-calendar>
            </div>
              <el-carousel height="100px" style="width:85%;height:100px;margin-left:12%;margin-top:-40px;" direction="vertical" :autoplay="false">
    <el-carousel-item>
       <div style="width:90%;height:33px;text-align:center;line-height: 33px;display: flex;border-bottom:1px solid #EAEDF1;">
                <div style="width:7px;height:7px;border-radius:6px;background: #13DFA0;margin:auto 10px;"></div>
                <span style="color:#606266;font-size:12px;">考勤打卡：正常</span>
              </div>
              <div style="width:90%;height:33px;text-align:center;line-height: 33px;display: flex;border-bottom:1px solid #EAEDF1;">
                <div style="width:7px;height:7px;border-radius:6px;background: #2878FF;margin:auto 10px;"></div>
                 <span style="color:#606266;font-size:12px;">工作审批：张三提交的请假申请，审批已通过！</span>
              </div>
              <div style="width:90%;height:33px;text-align:center;line-height: 33px;display: flex;border-bottom:1px solid #EAEDF1;">
                <div style="width:7px;height:7px;border-radius:6px;background: #2878FF;margin:auto 10px;"></div>
                 <span style="color:#606266;font-size:12px;">巡检异常：8号楼水泵机房漏水处理完成！</span>
              </div>
    </el-carousel-item>
        <el-carousel-item>
       <div style="width:90%;height:33px;text-align:center;line-height: 33px;display: flex;border-bottom:1px solid #EAEDF1;">
                <div style="width:7px;height:7px;border-radius:6px;background: #2878FF;margin:auto 10px;"></div>
                <span style="color:#606266;font-size:12px;">考勤打卡：正常</span>
              </div>
              <div style="width:90%;height:33px;text-align:center;line-height: 33px;display: flex;border-bottom:1px solid #EAEDF1;">
                <div style="width:7px;height:7px;border-radius:6px;background: #2878FF;margin:auto 10px;"></div>
                 <span style="color:#606266;font-size:12px;">工作审批：张三提交的请假申请，审批已通过！</span>
              </div>
              <div style="width:90%;height:33px;text-align:center;line-height: 33px;display: flex;border-bottom:1px solid #EAEDF1;">
                <div style="width:7px;height:7px;border-radius:6px;background: #2878FF;margin:auto 10px;"></div>
                 <span style="color:#606266;font-size:12px;">巡检异常：8号楼水泵机房漏水处理完成！</span>
              </div>
    </el-carousel-item>

  </el-carousel>
          </el-card>
        </el-col>
      </div>
    </el-row>
  </div>
</template>

<script>
import HomeDialog from "./HomeDialog.vue";
export default {
  components: {HomeDialog},
  name: "Home",
  data() {
    return {
      loginName:"",
      username:"",


      // date: new Date(),
      
      loading: false,
      firstRowGutter: 16,
      firstColXs: 24,
      firstColSm: 12,
      firstColMd: 6,
      firstColLg: 6,
      firstColXl: 6,
      thirdColXs: 24,
      thirdColMd: 12,
      value: new Date(),
      tableData:[{
        "Type":"投诉建议",
        "FQName":"张三",
        "FQBM":"项目部",
        "HJ":"审核中",
        "HJNAME":"超级管理员",
        "tIME":"2021-12-30",
      },{
        "Type":"品质检查",
        "FQName":"李四",
        "FQBM":"项目部",
        "HJ":"审核中",
        "HJNAME":"超级管理员",
        "tIME":"2021-12-30",
      },{
        "Type":"加班申请",
        "FQName":"王五",
        "FQBM":"人事",
        "HJ":"已完成",
        "HJNAME":"超级管理员",
        "tIME":"2021-12-27",
      },{
        "Type":"出差申请",
        "FQName":"刘二",
        "FQBM":"软件部",
        "HJ":"已完成",
        "HJNAME":"超级管理员",
        "tIME":"2021-12-29",
      }],
      RapidList:[ 
        {
          id:"1",
          name:"请假申请",
          img:require('../../assets/images/请假申请@3x.png'),
        },
        {
          id:"2",
          name:"出差申请",
          img:require('../../assets/images/出差申请@3x.png'),
        },{
          id:"3",
          name:"工作日志",
          img:require('../../assets/images/工作日志@3x.png'),
        },{
          id:"4",
          name:"合同管理",
          img: require('../../assets/images/合同管理@3x.png'),
        },{
          id:"5",
          name:"报修维修",
          img:require('../../assets/images/报修管理@3x.png'),
        },{
          id:"6",
          name:"投诉建议",
          img:require('../../assets/images/投诉建议@3x.png'),
        }
      ],
      RapidData:[ 
        {id:"1", name:"请假申请",img:require('../../assets/images/请假申请@3x.png')},
        {id:"2",name:"出差申请",img:require('../../assets/images/出差申请@3x.png')},
        {id:"3",name:"工作日志",img:require('../../assets/images/工作日志@3x.png')},
        {id:"4",name:"合同管理",img: require('../../assets/images/合同管理@3x.png')},
        {id:"5",name:"报修维修",img:require('../../assets/images/报修管理@3x.png')},
        {id:"6",name:"投诉建议",img:require('../../assets/images/投诉建议@3x.png')},
        {id:"7",name:"报销申请",img:require('../../assets/images/报销申请@3x.png')},
        {id:"8",name:"补卡申请",img:require('../../assets/images/补卡申请@3x.png')},
        {id:"9",name:"打卡记录",img:require('../../assets/images/打卡记录@3x.png')},
        {id:"10",name:"工程巡检",img:require('../../assets/images/工程巡检@3x.png')},
        {id:"11",name:"工作周报",img:require('../../assets/images/工作周报@3x.png')},
        {id:"12",name:"环境巡检",img:require('../../assets/images/环境维护巡检@3x.png')},
        {id:"13",name:"加班申请",img:require('../../assets/images/加班申请@3x.png')},
        {id:"14",name:"客服巡检",img:require('../../assets/images/客服巡检@3x.png')},
        {id:"15",name:"临时巡检",img:require('../../assets/images/临时巡检报备@3x.png')},
        {id:"16",name:"品质巡检",img:require('../../assets/images/品质巡检报备@3x.png')},
        {id:"17",name:"通知公告",img:require('../../assets/images/通知公告@3x.png')},
        {id:"18",name:"项目经理巡检",img:require('../../assets/images/项目经理巡检@3x.png')},
        {id:"19",name:"在职员工信息管理",img:require('../../assets/images/在职员工信息管理@3x.png')},
        {id:"20",name:"秩序维护巡检",img:require('../../assets/images/秩序维护巡检@3x.png')},
      ],

      calendarData:[ 
        {day: "2021-12-01", status:"pass",  type:"2",},
        {day: "2021-12-02", status:"pass",  type:"2",},
        {day: "2021-12-03", status:"pass", type:"2",},
        {day: "2021-12-06", status:"unpass", type:"2",},
        {day: "2021-12-07", status:"unpass",type:"1"},
        {day: "2021-12-08",status:"unpass", type:"2",},
        {day: "2021-12-09",status:"unpass", type:"2",},
        {day: "2021-12-10", status:"pass",  type:"2",},
        {day: "2021-12-11", status:"pass",  type:"0",},
        {day: "2021-12-12", status:"pass", type:"0",},
        {day: "2021-12-13", status:"unpass", type:"2",},
        {day: "2021-12-14", status:"unpass",type:"2"},
        {day: "2021-12-15",status:"unpass", type:"2",},
        {day: "2021-12-16",status:"unpass", type:"2",},
        {day: "2021-12-17", status:"pass",  type:"2",},
        {day: "2021-12-18", status:"pass",  type:"0",},
        {day: "2021-12-19", status:"pass", type:"0",},
        {day: "2021-12-20", status:"unpass", type:"0",},
        {day: "2021-12-21", status:"unpass",type:"0"},
        {day: "2021-12-22",status:"unpass", type:"0",},
        {day: "2021-12-23",status:"unpass", type:"0",},
        {day: "2021-12-24", status:"pass",  type:"0",},
        {day: "2021-12-25", status:"pass",  type:"0",},
        {day: "2021-12-26", status:"pass", type:"0",},
        {day: "2021-12-27", status:"unpass", type:"0",},
        {day: "2021-12-28", status:"unpass",type:"0"},
        {day: "2021-12-29",status:"unpass", type:"0",},
        {day: "2021-12-30",status:"unpass", type:"0",},
        {day: "2021-12-31",status:"unpass", type:"0",},
        ],
    }
  },
methods:{
  transaction(row){
    
  },
  shortcutClick(){
    this.$refs.HomeDialog.title = "自定义快捷导航设置";
    this.$refs.HomeDialog.dialogVisible = true; 
    this.$refs.HomeDialog.alter = true; 
    this.$refs.HomeDialog.RapidList = this.RapidList
    this.$refs.HomeDialog.RapidData = this.RapidData
  },
  RapidS(data){
    this.RapidList = data
  },
  calendarOnClick(e){
    var a = ""
    for(let val of this.calendarData){
      if(e.day == val.day){
        if(val.type == "0"){
          a="暂无考勤"
        }else if(val.type == "1"){
          a = "异常打卡"
        }else{
          a="打卡正常"
        }
         this.$notify({
          title: '考勤',
          message: "时间："+val.day+"; 考勤："+a,
          position: 'bottom-right'
        });
      }
    }
  },
},
  mounted() {
       let userInfo =  JSON.parse(localStorage.getItem("userName"))
       let loginName = userInfo.loginName
       let username = userInfo.name
       this.loginName = loginName
       this.username = username
  } 
}
</script>

<style scoped lang="scss">
.homeBody {
margin-left: 35px;
  .el-col {
    margin-bottom: 20px;
  }

  .firstRow {
    .el-col {
      .el-card {
        height: 136px;
      }
    }
  }

  .secondRow {
    .el-col {
      .el-card {
        height: 200px;
        margin-top:-7px;
      }
    }
  }

  .thirdRow {
    .el-col {
      .el-card {
        height: 420px;
        margin-top:-7px;
      }
    }
  }
}
.headPortrait{
  -moz-user-select: none;
-o-user-select:none;
-khtml-user-select:none;
-webkit-user-select:none;
-ms-user-select:none;
user-select:none;
  width:60px;height:60px;border-radius: 30px;
  margin-top: 20px;margin-left: 40px;
  overflow: hidden;
}
.personage{
  -moz-user-select: none;
-o-user-select:none;
-khtml-user-select:none;
-webkit-user-select:none;
-ms-user-select:none;
user-select:none;
  width: 150px;height: 60px;
  margin-left: 110px;margin-top: -50px;
  .personageP{
    font-weight: 600; line-height: 30px;text-align:left;
  }
  .personagePone{
    font-size: 13px;color: #999;
  }
}
.abnormal{
  -moz-user-select: none;
-o-user-select:none;
-khtml-user-select:none;
-webkit-user-select:none;
-ms-user-select:none;
user-select:none;
  width: 160px;height: 80px;margin-left: 60%;
  margin-top: -75px;line-height: 40px;text-align: center;
  .abnormalP{
    font-weight: 500;color: #606266;
    font-size: 14px;
  }
}
.abnormalone{
  -moz-user-select: none;
-o-user-select:none;
-khtml-user-select:none;
-webkit-user-select:none;
-ms-user-select:none;
user-select:none;
   width: 160px;height: 80px;margin-left: 80%;
  margin-top: -80px;line-height: 40px;text-align: center;
   .abnormalP{
    font-weight: 500;color: #606266;
    font-size: 14px;
  }
}
.task{
  -moz-user-select: none;
-o-user-select:none;
-khtml-user-select:none;
-webkit-user-select:none;
-ms-user-select:none;
user-select:none;
  width: 380px;height: 100px;
  margin-left: 30px;
  .taskPhoto{
    width: 60px;height: 60px;
    border-radius: 30px;
    margin-top: -70px;
    margin-left: 55%;
  }
}
.taskPhotone{
  -moz-user-select: none;
-o-user-select:none;
-khtml-user-select:none;
-webkit-user-select:none;
-ms-user-select:none;
user-select:none;
   width: 60px;height: 60px;
    border-radius: 30px;
    margin-top: -48px;
    margin-left: 130px;
}
.shortcut{
  -moz-user-select: none;
-o-user-select:none;
-khtml-user-select:none;
-webkit-user-select:none;
-ms-user-select:none;
user-select:none;
  width: 106.1%;height: 40px;border-bottom: 1px solid #EAEDF1;
  line-height: 40px;margin-top: -19px;
  padding-left: 40px;font-weight: 500;
  div{
    width: 23px;height: 23px;
    margin-top: -35px;
    margin-left: 90%;
  }
}
.quick{
  float: left;
  -moz-user-select: none;
-o-user-select:none;
-khtml-user-select:none;
-webkit-user-select:none;
-ms-user-select:none;
user-select:none;
  width: 50px;height:80px;
  margin-top: 30px;margin-left: 9%;text-align: center;
  div{
    width: 50px;height: 50px;margin-bottom: 5px;
  }
  span{
    line-height: 20px;color: #606266;font-size: 12px;
  }
}
.notice{
  -moz-user-select: none;
-o-user-select:none;
-khtml-user-select:none;
-webkit-user-select:none;
-ms-user-select:none;
user-select:none;
   width: 108.7%;height: 40px;border-bottom: 1px solid #EAEDF1;
  line-height: 40px;margin-top: -19px;margin-left: -20px;
  padding-left: 25px;
  u{
    font-size: 13px;color: #1890FF;
    margin-left: 74%;
  }
}
.proclamation{
  width: 100%;height: 35px;border-bottom: 1px solid #EAEDF1;
  line-height: 30px;
-moz-user-select: none;
-o-user-select:none;
-khtml-user-select:none;
-webkit-user-select:none;
-ms-user-select:none;
user-select:none;
line-height: 35px;
  .proclamationDiv{
    font-size:13px;color:#606266;font-weight:400;
    margin-top:-35px;height:35px;width:220px;margin-left:85px;
    line-height: 35px;text-align:left;
    white-space:nowrap;
    overflow:hidden;
    text-overflow:ellipsis;
  }
  .Stick{
      width: 30px;
      height: 20px;
      margin-top: -28px;
      margin-left: 310px;font-size:13px;
      color: #fff;
      background: #FF4D4F;
      line-height: 20px;
      text-align: center;
    }
  .proclamationD{
    font-size:13px;color:#606266;font-weight:400;
    height: 30px;margin-left: 75%;
    margin-top: -30px;
    line-height: 30px;
    text-align: center;
  }
  .proclamationD1{
    font-size:13px;color:#606266;font-weight:400;
    height: 30px;margin-left: 75%;
    margin-top: -25px;
    line-height: 30px;
    text-align: center;
  }
}
.backlog{
  -moz-user-select: none;
-o-user-select:none;
-khtml-user-select:none;
-webkit-user-select:none;
-ms-user-select:none;
user-select:none;
   width: 106%;height: 40px;border-bottom: 1px solid #EAEDF1;
  line-height: 40px;margin-top: -19px;margin-left: -20px;
  padding-left: 40px;
}

.attendance{
  -moz-user-select: none;
-o-user-select:none;
-khtml-user-select:none;
-webkit-user-select:none;
-ms-user-select:none;
user-select:none;
   width: 108.4%;height: 40px;
   border-bottom: 1px solid #EAEDF1;
  // border: 1px solid;
  line-height: 40px;margin-top: -19px;margin-left: -20px;
  padding-left: 40px;
}
.attendanceOne{
  -moz-user-select: none;
-o-user-select:none;
-khtml-user-select:none;
-webkit-user-select:none;
-ms-user-select:none;
user-select:none;
  width: 85%;
  height: 300px;
  margin-top: 10px;
  margin-left: 7%;
  // .prev{
  //   height: 25px;
  // }
}
</style>
<style>
.el-calendar-table .el-calendar-day{
  height: 30px !important;
  padding-left: 10;
  -moz-user-select: none;
-o-user-select:none;
-khtml-user-select:none;
-webkit-user-select:none;
-ms-user-select:none;
user-select:none;
font-size: 13px;
text-align: center;
/* line-height: 20px; */
}
.el-calendar-table thead th{
  font-size: 13px;
  padding: 5px;
  text-align: center;
}
.el-calendar__body{
  padding: 0;
}
.el-calendar__title{
  font-weight: 600;
}
.el-calendar-table td{
  border: none;
}
.el-calendar-table tr td:first-child{
  border: none;
}
.el-table td, .el-table th.is-leaf{
  text-align: center;
}
.el-calendar-table tr:first-child td{
  border: none;
}
.el-carousel__button{
  background: #D8D8D8;
}
.el-carousel__indicator--vertical .el-carousel__button{
  width: 5px;
}
</style>